import {
  SEARCH_TEXT,
  SET_FREECOPY_TOKEN,
  SET_GIFT_TOKEN,
  SET_LOCALE,
} from "actions/ActionTypes";
import i18n from "../i18n";

const initialState = {
  searchText: "",
  freecopy_token: "",
  gift_token: "",
  lang: i18n.language || i18n.options.fallbackLng[0],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_TEXT:
      return {
        ...state,
        searchText: action.searchText || "",
      };
    case SET_FREECOPY_TOKEN:
      return {
        ...state,
        freecopy_token: action.freecopy_token || "",
      };
    case SET_GIFT_TOKEN:
      return {
        ...state,
        gift_token: action.gift_token || "",
      };
    case SET_LOCALE:
      return {
        ...state,
        lang: action.lang || state.lang,
      };
    default:
      return state;
  }
};
